import { render, staticRenderFns } from "./FormSelector.vue?vue&type=template&id=72351cc6&scoped=true"
import script from "./FormSelector.vue?vue&type=script&lang=ts"
export * from "./FormSelector.vue?vue&type=script&lang=ts"
import style0 from "./FormSelector.vue?vue&type=style&index=0&id=72351cc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72351cc6",
  null
  
)

export default component.exports